/*
JS helpers
 */

// add :focusable selector
$.extend(jQuery.expr[':'], {
  focusable: function(el){
    return $(el).is('a, button, :input, [tabindex]');
  },
});
